export const forgotPasswordOptions = {
  props: ({mutate}) => ({
    forgotPasswordMutation: variables =>
      mutate({
        variables
      })
  })
};

export const resetPasswordOptions = {
  props: ({mutate}) => ({
    resetPasswordMutation: variables =>
      mutate({
        variables
      })
  })
};

export const setPasswordOptions = {
  props: ({mutate}) => ({
    setPasswordMutation: variables =>
      mutate({
        variables
      })
  })
};
